import { Rule } from '../types';

export const ruleRails: Rule = (submission) => {
  if (submission.config.heightIn <= 24) return null; // 600mm threshold ≈ 24"
  if (submission.config.railType !== 'aucun') return null;

  const usage = submission.config.usage;
  const suggestedRailType: 'barrotin' | 'barrotin_mains' =
    usage === 'com' ? 'barrotin_mains' : 'barrotin';
  const suggestedHeight = usage === 'com' ? '42"' : '36"';

  return {
    ruleId: 'rail-required-height',
    severity: 'error',
    humanMessage: `Garde-corps obligatoire (chute > 24" / 600 mm). Je propose ${suggestedRailType.replace('_', ' ')} ${suggestedHeight}.`,
    suggestion: {
      type: 'add-rail',
      patch: {
        config: { ...submission.config, railType: suggestedRailType },
      },
    },
  };
};
